import Common from '@vendor/js/common';
import { $ } from '@vendor/libs/jquery/jquery';
import { i18n } from '@vendor/libs/lang/lang';
const _OrderFormsCommonHandler = (function () {
    let settingsManuallyChanged = false;
    const settings = [
        'is_producer_enabled',
        'is_producer_list',
        'is_product_list',
        'is_product_unit_price_enabled',
        'is_comments_enabled',
        'is_quantity_enabled',
        'is_netto_price_enabled',
    ];
    const setupCloneModalHandler = (submitUrl) => {
        Common.handleModalForm('order_form_clone', {
            submitUrl,
        });
    };
    const setSettingsByPredefinedSetting = (input) => {
        for (const setting of settings) {
            const value = input.data(`app-${setting}`);
            if (['is_producer_list', 'is_product_list'].includes(setting)) {
                if (value) {
                    $(`[name="${setting}"][value="on"]`)
                        .prop('checked', true)
                        .trigger('change');
                    $(`[name="${setting}"][value="off"]`)
                        .prop('checked', false)
                        .trigger('change');
                }
                else {
                    $(`[name="${setting}"][value="on"]`)
                        .prop('checked', false)
                        .trigger('change');
                    $(`[name="${setting}"][value="off"]`)
                        .prop('checked', true)
                        .trigger('change');
                }
                continue;
            }
            $(`[name="${setting}"]`).prop('checked', value).trigger('change');
        }
        setTimeout(() => {
            settingsManuallyChanged = false;
        }, 100);
    };
    const setupTypeChangeHandler = () => {
        $('[name="predefined_setting"]').on('change', function () {
            if (!settingsManuallyChanged) {
                setSettingsByPredefinedSetting($(this));
            }
        });
    };
    const changeProducerListVisibility = () => {
        const isProducerEnabled = $('[name="is_producer_enabled"]').is(':checked');
        const isProducerListEnabled = $('[name="is_producer_list"][value="on"]').is(':checked');
        if (isProducerEnabled && isProducerListEnabled) {
            // $('[data-app-only_if="is_producer_list"]').show();
        }
        else {
            // $('[data-app-only_if="is_producer_list"]').hide();
        }
    };
    const sortDictionaryTable = (tableBody) => {
        const rows = tableBody
            .find('tr')
            .toArray()
            .sort((a, b) => {
            const t1 = $(a).find('input[name*="order"]').val();
            const t2 = $(b).find('input[name*="order"]').val();
            let s1 = parseInt(t1 ?? '99999999');
            let s2 = parseInt(t2 ?? '99999999');
            if (isNaN(s1)) {
                s1 = 99999999;
            }
            if (isNaN(s2)) {
                s2 = 99999999;
            }
            if (s1 == s2) {
                const name1 = $(a).find('input[name*="name"]').val();
                const name2 = $(b).find('input[name*="name"]').val();
                return window.naturalSort(name1, name2);
            }
            return s1 > s2 ? 1 : -1;
        });
        tableBody.empty();
        $.each(rows, (_index, row) => {
            tableBody.append(row);
        });
    };
    return {
        // Public functions
        init: function () {
            // setup changing specific inputs
            $('[name="predefined_setting"]').on('change', function () {
                const checkedInput = $('[name="predefined_setting"]:checked');
                const form = $(this).closest('form');
                const nameInput = form.find('[name="name"]');
                if (nameInput.attr('data-app-changed')) {
                    return;
                }
                const value = checkedInput.val();
                if (value == 'other') {
                    nameInput.val('');
                }
                else {
                    nameInput.val(i18n.trans(checkedInput.val()));
                }
            });
            $('[name="name"]').on('input', function () {
                $(this).attr('data-app-changed', true);
            });
            $('[name="is_producer_enabled"]')
                .on('change', function () {
                const form = $(this).closest('form');
                if ($(this).is(':checked')) {
                    form
                        .find('[name="is_producer_list"]')
                        .attr('disabled', false);
                }
                else {
                    form
                        .find('[name="is_producer_list"]')
                        .attr('disabled', true);
                }
                changeProducerListVisibility();
            })
                .trigger('change');
            $('[name="is_producer_list"]')
                .on('change', changeProducerListVisibility)
                .trigger('change');
            $('[name="is_product_list"]')
                .on('change', function () {
                const isProductListEnabled = $('[name="is_product_list"][value="on"]').is(':checked');
                if (isProductListEnabled) {
                    // $('[data-app-only_if="is_product_list"]').show();
                    $('[name="is_product_unit_price_enabled"]').attr('disabled', false);
                }
                else {
                    // $('[data-app-only_if="is_product_list"]').hide();
                    $('[name="is_product_unit_price_enabled"]').attr('disabled', true);
                }
            })
                .trigger('change');
            $('[type="checkbox"]').on('change', function () {
                if (settings.includes($(this).attr('name') ?? '')) {
                    settingsManuallyChanged = true;
                }
            });
        },
        setupTypeChangeHandler,
        sortDictionaryTable,
        setupCloneModalHandler,
    };
})();
window.OrderFormsCommonHandler = _OrderFormsCommonHandler;
